
import CompanyLayout from "../layouts/CompanyLayout";
import React, {useState, useEffect, useCallback,} from "react";
import { Container, Row, Col, Button, Card, Image, Alert } from 'react-bootstrap';
import axios from "axios";
import { FaDownload } from "react-icons/fa";
import config from "../config";
import { useParams } from "react-router-dom";
import { uploadedFileAlert } from "../alerts/Alerts";
import { deleteFileAlert, saveAlert } from "../alerts/Alerts";
import Layout from '../layouts/Layout';
import ClarityLogo from '../assets/images/clarity-logo.png';

const FileUpload = () => {
  const { caseId } = useParams();
  
  const [renewalCase, setRenewalcase] = useState([]);
  const [generalInfo, setGeneralInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState({ started: false, pc: 0 });
  const [uploadStatus, setUploadStatus] = useState("");

  const [file, setFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [uploadMessage, setUploadMessage] = useState("");


  const [username, setUsername] = useState(sessionStorage.getItem('username'));
  const [decodedToken, setDecodedToken] = useState(sessionStorage.getItem('decodedToken'));
  const [bearerToken, setBearerToken] = useState(sessionStorage.getItem('bearerToken'));

  useEffect(() => {
    const fetchcase = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/RenewalCases/${caseId}`);
        setRenewalcase(response.data);
      } catch (error) {
        console.error('Error fetching cases:', error);
      }
    };
    const fetchGeneralInfo = async () => {
        try {
            const response = await axios.get(`${config.API_URL}/EBGeneralInformations/ByCaseId/${caseId}`);
            setGeneralInfo(response.data || null);
        } catch (error) {
            setError('Error fetching plans.');
        } finally {
            setLoading(false);
        }
    };
    fetchGeneralInfo();
    fetchcase();
    fetchCaseFiles();
  }, []);

  const resetForm = () => {
    setSelectedFile(null);
    setSelectedFileName("");
  };

  const handleSave = () => {
    
  };

  const handleSubmit = () => {
   
    console.log("Submit Employee Benefits clicked");
  };

 

  const fetchCaseFiles = async () => {
    try {
      const response = await axios.get(`${config.API_URL}/CaseFiles/${caseId}`);
      setFiles(response.data || []);
    } catch (error) {
      if (error.response?.status !== 404) {
        setError("Error fetching files.");
      }
    } finally {
      setLoading(false);
    }
  };

  const getFileNameFromURL = (url) => {
    try {
        const urlObject = new URL(url);
        const fileName = decodeURIComponent(urlObject.pathname.split('/').pop());
        const fileNameWithoutId = fileName.split('_').slice(0, -1).join('_');
        return fileNameWithoutId;
    } catch (error) {
        console.error('Invalid URL:', url);
        return '';
    }
};

const uploadCobraBenefitsFile = async (event) => {
  event.preventDefault();

  if (!file) {
    setUploadStatus("No file selected.");
    return;
  }

  // Helper to format date
  const formatDate = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");

    return (
      date.getFullYear() +
      pad(date.getMonth() + 1) +
      pad(date.getDate())
    );
  };

  const formatDateTime = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");

    return (
      date.getFullYear() +
      pad(date.getMonth() + 1) +
      pad(date.getDate()) +
      "-" +
      pad(date.getHours()) +
      pad(date.getMinutes()) +
      pad(date.getSeconds())
    );
  };

  
  const BEN_CODE = renewalCase?.bencode; 
  const renewalDate = new Date(renewalCase?.renewalDate); 
  const uploadDate = new Date();

  const newFileName = `${BEN_CODE}-${formatDate(renewalDate)}-Enrollment File-${formatDateTime(uploadDate)}.${file.name.split('.').pop()}`;

  setSelectedFileName(newFileName);

  const formData = new FormData();

  
  formData.append("file", file, newFileName);

  setSelectedFile((prevState) => {
    return { ...prevState, started: true };
  });

  try {
    const blobResponse = await axios.post(
      `${config.API_URL}/BlobUploads/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const fileUrl = blobResponse.data.fileUrl;

    const caseFile = {
      fileURL: fileUrl,
      fileCategory: "Enrollment Template",
      status: "Uploaded",
      uploadedBy: username,
      uploadedDate: new Date().toISOString(),
      caseId: caseId,
    };

    await axios.post(`${config.API_URL}/CaseFiles`, caseFile);

    setUploadStatus(`File uploaded successfully: ${newFileName}`);

    uploadedFileAlert(resetForm);
    fetchCaseFiles();

  } catch (error) {
    console.error("Error during file upload:", error);
    setUploadStatus("File upload failed.");
  }
};

  const handleDeleteFile = async (fileUrl, fileId) => {
    try {
        const caseFile = {
            fileURL: fileUrl,
            fileCategory: "Enrollment Template",
            status: "Deleted",
            deletedBy: username,
            deletedDate: new Date().toISOString(),
            caseId: caseId
        };

        await Promise.all([
            axios.post(`${config.API_URL}/CaseFiles`, caseFile),
            axios.delete(`${config.API_URL}/CaseFiles/${fileId}`)
        ]);

        setFiles((prevFiles) => prevFiles.filter((file) => file.id !== fileId));
    } catch (error) {
        console.error('Error deleting file:', error);
        
    }
};

  // const handleDeleteFile = async (fileId) => {
  //   try {
  //     await axios.delete(`${config.API_URL}/CaseFiles/${fileId}`);

  //     setFiles((prevFiles) => prevFiles.filter((file) => file.id !== fileId));
  //   } catch (error) {
  //     console.error("Error deleting file:", error);
  //   }
  // };


  if (!username) return (<Layout>
    <div className="confirmation-container mt-5">
      <Card className="confirmation-card shadow-lg p-3 mb-5 bg-white rounded">
        <div className="text-center mb-4">
          <Image src={ClarityLogo} alt="Company Logo" className="confirmation-logo" />
        </div>
  
        <Alert variant="danger" className="text-center">Please login from the portal</Alert>
  
  
  
      </Card>
    </div>
  </Layout>);

  return (
    <div>
      <CompanyLayout caseId={caseId} renewalCase={renewalCase}>
        <div className="row fixedHeader">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div className="d-flex justify-content-start"></div>
              <div className="d-flex justify-content-center">
                <span id="page-title">
                  You are currently renewing benefits for <strong>{renewalCase?.employerName || " "}</strong>.
                </span>
              </div>
              <div className="d-flex justify-content-end">
                <span className="pt-1 me-2" id="autoSavedMessage"></span>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-1 d-flex justify-content-end">
           

            <button
              type="button"
              className="btn btn-primary btn-sm mt-1 me-1 save-company-profile"
              onClick={saveAlert}
            >
              SAVE
            </button>

            
          </div>
          <div className="col-lg-12 progress-position">
            <div className="progress mb-3">
              {/* <div
                className="progress-bar progress-bar-success"
                role="progressbar"
                style={{ width: '22%' }}
              >
                <span id="totalProgress">22%</span>
              </div> */}
              <div
                className="progress-bar progress-bar-warning"
                role="progressbar"
                style={{ width: '100%' }}
              >
                <span id="pendingProgress"></span>
              </div>
            </div>
          </div>
        </div>

        <div id="page-content-wrapper">
          <div className="container-fluid">
            <div className="row startingrow">
              <h5 className="communication-label">File Uploads</h5>

              <div className="col-lg-12 mb-3" id="c1">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">Employee Benefits</h5>
                    <div className="mb-0">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="d-flex justify-content-center mb-3">
                              <div className="col-lg-12">
                                <div className="table-responsive">
                                  <table
                                    className="styled-table"
                                    cellSpacing={0}
                                    width="100%"
                                  >
                                    <thead>
                                      <tr>
                                        <th className="fileUploads-table-row">
                                          File Category
                                        </th>
                                        <th
                                          colSpan="2"
                                          className="fileUploads-table-row"
                                        >
                                          File Uploads
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <th
                                          className="vertical-th fileUploadsCobrabenefits"
                                          scope="row"
                                          style={{
                                            width: "30%",
                                            textAlign: "center",
                                          }}
                                        >
                                          <span className="FileURLElements browse-text pt-1">
                                            Enrollment Template 
                                          </span>
                                          <a
  href={require("../assets/docs/Enrollment_Template.xlsx")} // Correct path
  className="ms-2"
  download
>
                                            <i className="fas fa-download btn-icon"></i>
                                          </a>
                                        </th>
                                        <td className="fileuploads-table-row">
                                          <div className="upload-section-funding">
                                            <div className="d-flex justify-content-around mb-1 pt-1">
                                              <input
                                                type="file"
                                                accept=".pdf, .xlsx, .xls, .csv"
                                                disabled={generalInfo?.isHRAClient && renewalCase?.caseStatus !== 'Awaiting Files'}
                                                onChange={(e) => {
                                                  const selectedFile =
                                                    e.target.files[0];
                                                  setFile(selectedFile); // Set the file in state
                                                  setSelectedFileName(
                                                    selectedFile.name
                                                  ); // Set the selected file name
                                                  e.target.value = null;
                                                }}
                                              />
                                              <label className="file-input-label pt-2">
                                                {selectedFileName ? (
                                                  <span>
                                                    {selectedFileName}
                                                  </span>
                                                ) : (
                                                  <span>
                                                    Browse files here.
                                                    <br />
                                                    Acceptable file formats
                                                    include .pdf, .xlsx, .xls,
                                                    and .csv
                                                  </span>
                                                )}
                                              </label>
                                              {selectedFileName && (
                                                <button
                                                  className="btn btn-success emp-upload-button btn-sm mt-2"
                                                  onClick={
                                                    uploadCobraBenefitsFile
                                                  }
                                                  type="button"
                                                  disabled={generalInfo?.isHRAClient && renewalCase?.caseStatus !== 'Awaiting Files'}
                                                >
                                                  Click to Upload
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            {(generalInfo?.isHRAClient && renewalCase?.caseStatus !== 'Awaiting Files') ? (
                                <>
                                <div className="d-flex justify-content-center mb-1">
                              <span>
                                <em>
                                Upload is not available until changes are submitted and we have processed your plan changes. We will notify when it is time to upload your enrollment file.
                                </em>
                              </span>
                            </div>
                            
                                </>
                            ): (generalInfo?.isHRAClient && renewalCase?.caseStatus === 'Awaiting Files') ? (
                                <>
                                <div className="d-flex justify-content-center mb-1">
                              <span>
                                <em>
                                To ensure your participants are enrolled in the correct plans, please upload your enrollment file. You can download an Enrollment Template below.  To review or print your Renewal Summary click “Summary”.
                                </em>
                              </span>
                            </div>
                                </>
                            ) :(
                                <>
                                <div className="d-flex justify-content-center mb-1">
                              <span>
                                <em>
                                  By uploading this file, you are confirming
                                  there are no further plan changes.
                                </em>
                              </span>
                            </div>
                            <div className="d-flex justify-content-center mb-3">
                              <span>
                                <em>
                                  If you need to make plan changes, please
                                  update the “Employee Benefit” section and
                                  Submit.
                                </em>
                              </span>
                            </div>
                                </>
                            )}
                            

                            <div className="col-lg-8 ">
                              <div className="table-responsive">
                                <table
                                  className="table"
                                  cellSpacing="0"
                                  width="100%"
                                >
                                  <thead>
                                    <tr>
                                      <th className="fileUploads-table-row">
                                        File Name
                                      </th>
                                      <th className="fileUploads-table-row">
                                        File Category
                                      </th>
                                      <th className="fileUploads-table-row">
                                        Uploaded Date
                                      </th>
                                      <th className="fileUploads-table-row d-flex justify-content-center">
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {files.filter((file) =>file.fileCategory === "Enrollment Template" && file.caseId === caseId && file.status != "Deleted")
                                      .map((file, idx) => (
                                        <tr key={idx}>
                                          <th
                                            className="vertical-th fileUploadsCobrabenefits"
                                            scope="row"
                                          >
                                            <span className="FileURLElements browse-text">
                                                {getFileNameFromURL(file.fileURL)} {/* Displaying the file name */}
                                            </span>
                                          </th>
                                          <td>{file.fileCategory}</td>
                                          <td>{ file.uploadedDate ? new Date(file.uploadedDate).toISOString().split('T')[0] : ''}</td>
                                          <td className="d-flex justify-content-between">
                                            <a
                                              href={file.fileURL}
                                              className=""
                                              download=""
                                              style={{ textDecoration: "none" }}
                                            >
                                              <FaDownload
                                                style={{ fontSize: "20px" }}
                                              />
                                            </a>
                                            <button
                                              type="button"
                                              className="deleteFile"
                                              onClick={() =>
                                                deleteFileAlert(
                                                  file.fileURL,
                                                  file.id,
                                                  handleDeleteFile
                                                )
                                              }
                                            >
                                              <span className="fa fa-trash-alt me-1"></span>
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CompanyLayout>
    </div>
  );
};

export default FileUpload;
